import { useEffect, type FC } from 'react'
import type { SylveraSpinnerProps } from './types'
import { useRive } from '@rive-app/react-canvas'

export const SylveraSpinner: FC<SylveraSpinnerProps> = ({
  subtle = false,
  className,
}) => {
  const src = subtle
    ? '/assets/design-system/rive/spinner_subtle.riv'
    : '/assets/design-system/rive/spinner_default.riv'

  const { RiveComponent, rive } = useRive({
    src,
    autoplay: true,
  })

  // Load the new animation when the subtle prop changes. This is needed as the
  // useRive hook only fetches the animation file once for optimisation reasons.
  useEffect(() => {
    if (rive) {
      rive.load({
        src,
        autoplay: true,
      })
    }
  }, [subtle])

  return <RiveComponent className={className} />
}
